<template>
  <div
    id="buttonsMap"
  >
    <!-- Centrar mapa -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('home')"
        >
          <v-icon>esri-icon-home</v-icon>
        </v-btn>
      </template>
      <span>Centrar</span>
    </v-tooltip>

    <!-- Orientar norte
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn fab tile :x-small="isButtonXSmall" :small="!isButtonXSmall" v-bind="attrs" v-on="on" @click="eventButton('orientar')">
          <v-icon>esri-icon-compass</v-icon>
        </v-btn>
      </template>
      <span>Orientar</span>
    </v-tooltip>
-->
    <!-- Buscar coordenadas -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('searchCoords')"
        >
          <v-icon>esri-icon-search</v-icon>
        </v-btn>
      </template>
      <span>Buscador coordenadas</span>
    </v-tooltip>

    <!-- Resumen medios -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('resumenMedios')"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <span>Resumen de medios</span>
    </v-tooltip>

    <!-- Capas -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('layerList')"
        >
          <v-icon>esri-icon-layer-list</v-icon>
        </v-btn>
      </template>
      <span>Capas</span>
    </v-tooltip>

    <!-- Vista 3D -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          v-show="is2D"
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('3D')"
        >
          <span
            class="text-button font-weight-bold"
          >3D</span>
        </v-btn>
      </template>
      <span>Vista 3D</span>
    </v-tooltip>

    <!-- Vista 2D -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          v-show="!is2D"
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('2D')"
        >
          <span
            class="text-button font-weight-bold"
          >2D</span>
        </v-btn>
      </template>
      <span>Vista 2D</span>
    </v-tooltip>

    <!-- Mapas base -->
    <v-speed-dial
      v-model="sdBasemaps"
      direction="left"
      transition="slide-x-reverse-transition"
    >
      <!-- Botón principal (sin tooltip) -->
      <template
        #activator
      >
        <v-btn
          v-model="sdBasemaps"
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
        >
          <v-icon
            v-if="sdBasemaps"
          >
            mdi-close
          </v-icon>
          <v-icon
            v-else
          >
            esri-icon-basemap
          </v-icon>
        </v-btn>
      </template>

      <!-- Botones mapas base con tooltip -->
      <v-tooltip
        v-for="(basemap, i) in basemaps"
        :key="i"
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            fab
            icon
            color="transparent"
            v-bind="attrs"
            v-on="on"
            @click="setBaseMap(basemap)"
          >
            <v-avatar>
              <img
                :src="require(`@/assets/basemap/${basemap.icon}`)"
                height="100%"
                width="100%"
              >
            </v-avatar>
          </v-btn>
        </template>
        <span>{{ basemap.label }}</span>
      </v-tooltip>
    </v-speed-dial>

    <!-- Zoom+ -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          v-show="!$vuetify.breakpoint.mobile"
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('zoomIn')"
        >
          <v-icon>esri-icon-zoom-in-magnifying-glass</v-icon>
        </v-btn>
      </template>
      <span>Ampliar zoom</span>
    </v-tooltip>

    <!-- Zoom- -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          v-show="!$vuetify.breakpoint.mobile"
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('zoomOut')"
        >
          <v-icon>esri-icon-zoom-out-magnifying-glass</v-icon>
        </v-btn>
      </template>
      <span>Disminuir zoom</span>
    </v-tooltip>

    <!-- Compartir mapa -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          :color="shareMapButtonColor"
          v-on="on"
          @click="shareMap"
        >
          <v-icon>mdi-monitor-share</v-icon>
        </v-btn>
      </template>
      <span> {{ isSharingMap ? 'Salir de compartir mapa' : 'Compartir mapa' }} </span>
    </v-tooltip>

    <!-- Dibujar compartir mapa -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <div
          v-bind="attrs"
          v-on="on"
        >
          <v-speed-dial
            v-show="showBtnGraphics"
            v-model="sdGraficos"
            direction="left"
            transition="slide-x-reverse-transition"
          >
            <template
              #activator
            >
              <v-btn
                v-model="sdGraficos"
                fab
                tile
                :x-small="isButtonXSmall"
                :small="!isButtonXSmall"
              >
                <v-icon
                  v-if="sdGraficos"
                >
                  mdi-close
                </v-icon>
                <v-icon
                  v-else
                >
                  esri-icon-edit
                </v-icon>
              </v-btn>
            </template>

            <!-- Botones graficos -->
            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="drawGraphicShareMap('point')"
                >
                  <v-icon>esri-icon-blank-map-pin</v-icon>
                </v-btn>
              </template>
              <span>Punto</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="drawGraphicShareMap('multipoint')"
                >
                  <v-icon>esri-icon-handle-horizontal</v-icon>
                </v-btn>
              </template>
              <span>Multi punto</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="drawGraphicShareMap('polyline')"
                >
                  <v-icon>esri-icon-polyline</v-icon>
                </v-btn>
              </template>
              <span>Línea</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="drawGraphicShareMap('polygon')"
                >
                  <v-icon>esri-icon-polygon</v-icon>
                </v-btn>
              </template>
              <span>Polígono</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="drawGraphicShareMap('reset')"
                >
                  <v-icon>esri-icon-trash</v-icon>
                </v-btn>
              </template>
              <span>Borrar</span>
            </v-tooltip>
          </v-speed-dial>
        </div>
      </template>
      <span>Gráficos</span>
    </v-tooltip>

    <!-- Capturar mapa -->
    <!-- <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn fab tile :x-small="isButtonXSmall" :small="!isButtonXSmall" v-bind="attrs" v-on="on" @click="eventButton('captureMap')">
          <v-icon>esri-icon-media</v-icon>
        </v-btn>
      </template>
      <span>Capturar mapa</span>
    </v-tooltip> -->

    <!-- Medicion -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <div
          v-bind="attrs"
          v-on="on"
        >
          <v-speed-dial
            v-model="sdMedicion"
            direction="left"
            transition="slide-x-reverse-transition"
          >
            <template
              #activator
            >
              <v-btn
                v-model="sdMedicion"
                fab
                tile
                :x-small="isButtonXSmall"
                :small="!isButtonXSmall"
              >
                <v-icon
                  v-if="sdMedicion"
                >
                  mdi-close
                </v-icon>
                <v-icon
                  v-else
                >
                  esri-icon-measure
                </v-icon>
              </v-btn>
            </template>

            <!-- Botones graficos -->
            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="measure('distance')"
                >
                  <v-icon>esri-icon-measure-line</v-icon>
                </v-btn>
              </template>
              <span>Medir distancia</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="measure('area')"
                >
                  <v-icon>esri-icon-measure-area</v-icon>
                </v-btn>
              </template>
              <span>Medir área</span>
            </v-tooltip>

            <v-tooltip
              bottom
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-btn
                  fab
                  tile
                  :x-small="isButtonXSmall"
                  :small="!isButtonXSmall"
                  v-bind="attrs"
                  v-on="on"
                  @click="clearMeasurement()"
                >
                  <v-icon>esri-icon-trash</v-icon>
                </v-btn>
              </template>
              <span>Borrar medidas</span>
            </v-tooltip>
          </v-speed-dial>
        </div>
      </template>
      <span>Medir</span>
    </v-tooltip>

    <!-- Dialogo confirmacion salida de compartir pantalla -->
    <v-dialog
      v-model="confirmStopSharing"
      max-width="400"
    >
      <v-card>
        <v-toolbar
          color="primaryLight"
          dark
          dense
        >
          <v-toolbar-title>Compartir mapa</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <p
            class="pt-3 black--text body-1"
          >
            Estás a punto de salir de compartir el mapa. ¿Estás seguro?
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="confirmStopSharing = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red"
            text
            @click="confirmShareMapStop"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Track area -->
    <v-tooltip
      bottom
    >
      <template
        #activator="{ on, attrs }"
      >
        <v-btn
          fab
          tile
          :x-small="isButtonXSmall"
          :small="!isButtonXSmall"
          v-bind="attrs"
          v-on="on"
          @click="eventButton('drawHistoricoPolygon')"
        >
          <v-icon>esri-icon-polygon</v-icon>
        </v-btn>
      </template>
      <span>Historico en un area</span>
    </v-tooltip>

    <!-- Simulacion
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn fab tile :x-small="isButtonXSmall" :small="!isButtonXSmall" v-bind="attrs" v-on="on" @click="eventButton('showDialogSimulacion')">
          <v-icon>mdi-pine-tree-fire</v-icon>
        </v-btn>
      </template>
      <span>Simulacion</span>
    </v-tooltip> -->

    <!-- Emergencias
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn fab tile :x-small="isButtonXSmall" :small="!isButtonXSmall" v-bind="attrs" v-on="on" @click="eventButton('showDialogEmergencias')">
          <v-icon>mdi-car-brake-alert</v-icon>
        </v-btn>
      </template>
      <span>Emergencias activas</span>
    </v-tooltip> -->

    <!-- Geofencing
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn fab tile :x-small="isButtonXSmall" :small="!isButtonXSmall" v-bind="attrs" v-on="on" @click="eventButton('showDialogGeofencing')">
          <v-icon>mdi-alert</v-icon>
        </v-btn>
      </template>
      <span>Geofencing</span>
    </v-tooltip> -->
    <vx-dialog-track-polygon
      :show="showDialogPolygonHistorico"
      @aceptar="startDrawHistoricoPolygon"
      @cancelar="cancelDialogHistoricoPolygono"
    />

    <!-- Compass widget -->
    <div
      v-show="is3D"
      id="compassWidget"
      class="compass"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import api from '@/api'
import * as ArcGIS from '@/helpers/ArcGIS'
import DialogFechaTrackeMedioArea from './DialogFechaTrackeMedioArea.vue'

export default {

  components: {
    'vx-dialog-track-polygon': DialogFechaTrackeMedioArea
  },
  data: () => ({
    is2D: true,

    sdBasemaps: false,
    sdGraficos: false,
    sdMedicion: false,
    sdPolygonAreaTrack: false,
    showDialogPolygonHistorico: false,
    mediosInPolygon: [],

    confirmStopSharing: false
  }),

  computed: {
    ...mapGetters('shareMap', [
      'isSharingMap',
      'requestShareMap',
      'host'
    ]),

    ...mapGetters('map', [
      'paramsComunidad',
      'basemaps',
      'isMap3D'
    ]),

    ...mapGetters('medio', [
      'medios'
    ]),

    ...mapGetters('usuario', [
      'currentUsuario'
    ]),

    isButtonXSmall() {
      return this.$vuetify.breakpoint.name === 'md' || this.$vuetify.breakpoint.mobile
    },

    shareMapButtonColor() {
      return this.isSharingMap ? 'red' : 'white'
    },

    showBtnGraphics() {
      return this.isSharingMap && this.host
    },

    is3D() {
      return this.isMap3D
    }

  },

  mounted() {
    this.$eventHub.$on('change2D', this.change2D)
  },

  beforeDestroy() {
    this.$eventHub.$off('change2D', this.change2D)
  },

  methods: {
    ...mapActions('shareMap', ['activar2D']),

    eventButton(event) {
      this.$log.debug('typeEventButton', event)

      switch (event) {
        case 'home':
          ArcGIS.setExtent(this.paramsComunidad.EXTENT)
          break
        // case 'orientar':
        //   ArcGIS.centerCompass()
        //   break
        case 'searchCoords':
          this.$emit('showSearchCoords')
          break
        case 'layerList':
          this.$emit('showLayerList')
          break
        case '3D':
          this.is2D = !this.is2D
          ArcGIS.use3D()
          this.activar2D(false)
          break
        case '2D':
          this.is2D = !this.is2D
          ArcGIS.use2D()
          this.activar2D(true)
          break
        case 'zoomIn':
          ArcGIS.setZoom(+1)
          break
        case 'zoomOut':
          ArcGIS.setZoom(-1)
          break
        case 'captureMap':
          this.captureMap()
          break
        case 'showDialogSimulacion':
          this.$emit('showDialogSimulacion')
          break
        case 'showDialogEmergencias':
          this.$emit('showDialogEmergencias')
          break

        case 'showDialogGeofencing':
          this.$emit('showDialogGeofencing')
          break
        case 'drawHistoricoPolygon':
          this.drawHistoricoPolygon()
          break
        case 'resumenMedios':
          this.$emit('showResumenMedios')
          break
        default:
          console.error('Boton desconocido:', event)
      }
    },

    changeMapView() {
      if (this.is2D) {
        this.eventButton('3D')
      } else {
        this.eventButton('2D')
      }

      this.is2D = !this.is2D
    },

    setBaseMap(basemap) {
      ArcGIS.setBaseMap(basemap)
    },

    shareMap() {
      if (this.isSharingMap) {
        this.confirmStopSharing = true
      } else {
        this.$eventHub.$emit('shareMap', true)
      }
    },

    confirmShareMapStop() {
      this.$eventHub.$emit('shareMap', false)
      this.confirmStopSharing = false
    },

    drawGraphicShareMap(type) {
      const event = {
        function: type
      }

      ArcGIS.paintEventShareMap(event)
    },

    async captureMap() {
      const base64Img = await ArcGIS.captureMap()

      this.$root.$confirmDialog.open('¿Está seguro?', 'Enviar captura a Telegram').then(result => {
        if (result) {
          const msg = {
            image: base64Img.substr(22),
            user: this.currentUsuario.USUARIO
          }

          api.others.sendMapCapture(msg)
        }
      })
    },

    measure(type) {
      ArcGIS.measure(type)
    },

    clearMeasurement() {
      ArcGIS.clearMeasurement()
    },

    drawHistoricoPolygon() {
      if (!this.sdPolygonAreaTrack) {
        this.showDialogPolygonHistorico = true
      } else {
        this.sdPolygonAreaTrack = false

        for (let i = 0; i < this.mediosInPolygon.length; i++) {
          ArcGIS.hideTrack(this.mediosInPolygon[i])
        }

        this.mediosInPolygon = []
      }
    },

    async startDrawHistoricoPolygon(fecha1, fecha2) {
      this.showDialogPolygonHistorico = false
      this.sdPolygonAreaTrack = true

      this.$emit('showSnackBarDibujando')
      const poligono = await ArcGIS.drawPolygonAreaToTrackMedios()

      if (poligono) {
        this.$emit('showSnackBarDibujando')

        this.isLoadingTrack = true
        this.$emit('showSnackBarLoading')

        const data = {
          coordenadasPoligono: poligono,
          fechaInit: fecha1,
          fechaFin: fecha2
        }

        try {
          const response2 = await api.medio.getTrackFechasInPolygon(data)
          if (response2.status === 200) {
            for (const key in response2.data) {
              const posiciones = response2.data[key]
              const medio = this.medios.find(element => element.ID_MEDIO === key)
              this.mediosInPolygon.push(key)

              ArcGIS.drawTrack(key, medio.MEDIO, posiciones, false)
            }

            this.$emit('showSnackBarLoading')
          } else if (response2.status === 204) {
            this.$emit('showSnackBarLoading')
            this.$emit('showSnackBarError', 'No han actuado medios en este área en las fechas indicadas')
            this.sdPolygonAreaTrack = false
          }
        } catch (error) {
          this.$emit('showSnackBarLoading')
          this.$emit('showSnackBarError', 'Se produjo un error en el servidor')
          this.sdPolygonAreaTrack = false
        }
      } else {
        this.$emit('showSnackBarDibujando')
      }
    },
    cancelDialogHistoricoPolygono() {
      this.showDialogPolygonHistorico = false
    },
    cancelDrawingPolygon() {
      this.sdPolygonAreaTrack = false
      ArcGIS.cancelDrawingPolygon()
    },

    change2D(estado) {
      this.is2D = estado
    }
  }
}
</script>

<style scoped>
  #buttonsMap {
    position: absolute;
    top: 70px;
    right: 15px;
    /* overflow-y: auto; */
    height: calc(100% - 160px) !important; /* 26 px footer */
  }

  #buttonsMap button {
    display: block;
    margin-top: 7px;
  }

  .compass {
    margin-top: 7px;
  }
</style>
